module.exports = __webpack_public_path__ + "img/set-up-background.161b1bfc.png";